import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeDomainFromAllAttributesData =
  (domain: string) => (model: Model) => {
    let didRemove = false;
    const newAttributesByIri = Object.values(
      model.modelData.attributesByIri
    ).reduce<Record<string, ModelConceptAttribute>>((acc, attribute) => {
      const { [domain]: _, ...domains } = attribute.domains;
      if (domain) {
        didRemove = true;
      }
      acc[attribute.value] = {
        ...attribute,
        domains,
      };
      return acc;
    }, {});

    if (!didRemove) {
      return;
    }

    setDataProperty<ModelData>(model)(
      model.modelData,
      'attributesByIri',
      newAttributesByIri
    );
  };
